'use client';
import React, { useState } from 'react';
import TradeCard from './TradeCard';

// Backend integration point: fetch live trade ideas from AI engine / database
export const tradeIdeas = [
  {
    id: 'trade-001',
    symbol: 'TCS',
    name: 'Tata Consultancy Services',
    market: 'Indian',
    exchange: 'NSE',
    cmp: 4218.40,
    entry: '4,180 – 4,220',
    stopLoss: 4090,
    target1: 4420,
    target2: 4680,
    rr: '2.8:1',
    type: 'Swing' as const,
    setup: 'Breakout' as const,
    risk: 'Medium' as const,
    confidence: 87,
    sector: 'IT',
    indicators: ['RSI 62', 'MACD Bullish', 'Above 50 EMA'],
    aiAnalysis: 'TCS broke above a 6-week consolidation range on strong volume (2.4M vs avg 1.1M). FII buying in IT sector + Q4 beat supports continuation. Entry on pullback to breakout zone at 4,180–4,220.',
    beginnerNote: 'TCS is India\'s largest IT company. It recently released strong quarterly results and its stock price broke out of a sideways pattern. This means buyers are in control. Buy when price dips slightly to the entry zone, keep your stop loss below the breakout point.',
    trend: 'up' as const,
    volume: '+118%',
    lastUpdated: '09:38 AM',
  },
  {
    id: 'trade-002',
    symbol: 'RELIANCE',
    name: 'Reliance Industries Ltd',
    market: 'Indian',
    exchange: 'NSE',
    cmp: 2984.60,
    entry: '2,960 – 2,990',
    stopLoss: 2880,
    target1: 3120,
    target2: 3280,
    rr: '2.4:1',
    type: 'Swing' as const,
    setup: 'Momentum' as const,
    risk: 'Low' as const,
    confidence: 82,
    sector: 'Energy',
    indicators: ['RSI 58', 'VWAP Support', 'Bollinger Mid'],
    aiAnalysis: 'RELIANCE holding above VWAP and 200 EMA with improving momentum. Jio subscriber growth and retail segment expansion provide fundamental tailwind. Low-risk swing setup with defined levels.',
    beginnerNote: 'Reliance is one of India\'s biggest companies. The stock is trading above its average price and showing strong buying interest. This is a lower-risk trade because the stop loss is well-defined and the company has strong business fundamentals.',
    trend: 'up' as const,
    volume: '+42%',
    lastUpdated: '09:40 AM',
  },
  {
    id: 'trade-003',
    symbol: 'ADANIPORTS',
    name: 'Adani Ports & SEZ',
    market: 'Indian',
    exchange: 'NSE',
    cmp: 1342.80,
    entry: '1,320 – 1,350',
    stopLoss: 1265,
    target1: 1460,
    target2: 1580,
    rr: '2.1:1',
    type: 'Swing' as const,
    setup: 'Reversal' as const,
    risk: 'High' as const,
    confidence: 68,
    sector: 'Infrastructure',
    indicators: ['RSI 42 Oversold', 'Support Zone', 'Divergence'],
    aiAnalysis: 'ADANIPORTS showing bullish divergence on daily RSI after testing strong support at 1,310–1,320. Volume picking up at support. High-risk trade due to group-level news sensitivity. Strict stop loss mandatory.',
    beginnerNote: 'This is a higher-risk trade. The stock has fallen a lot and is now near a support level where buyers tend to step in. The AI spotted a pattern called "bullish divergence" which sometimes signals a bounce. Only trade with money you can afford to lose, and respect the stop loss strictly.',
    trend: 'down' as const,
    volume: '+67%',
    lastUpdated: '09:35 AM',
  },
  {
    id: 'trade-004',
    symbol: 'HDFCBANK',
    name: 'HDFC Bank Ltd',
    market: 'Indian',
    exchange: 'NSE',
    cmp: 1648.90,
    entry: '1,635 – 1,655',
    stopLoss: 1590,
    target1: 1740,
    target2: 1820,
    rr: '2.6:1',
    type: 'Intraday' as const,
    setup: 'Breakout' as const,
    risk: 'Medium' as const,
    confidence: 79,
    sector: 'Banking',
    indicators: ['RSI 55', 'Opening Range Breakout', 'High Volume'],
    aiAnalysis: 'HDFCBANK attempting opening range breakout above 1,648 on elevated volumes. Bank Nifty recovery expected to support. Intraday target achievable within session. Exit before 3:15 PM IST.',
    beginnerNote: 'This is a same-day trade (intraday), meaning you must buy and sell within the same trading day. HDFC Bank\'s price broke above its first 30-minute high — a signal that buyers are strong. Exit this trade before the market closes at 3:30 PM.',
    trend: 'up' as const,
    volume: '+89%',
    lastUpdated: '09:42 AM',
  },
  {
    id: 'trade-005',
    symbol: 'AAPL',
    name: 'Apple Inc.',
    market: 'US',
    exchange: 'NASDAQ',
    cmp: 189.42,
    entry: '$187.50 – $190.00',
    stopLoss: 182.0,
    target1: 198.5,
    target2: 208.0,
    rr: '2.9:1',
    type: 'Swing' as const,
    setup: 'Breakout' as const,
    risk: 'Low' as const,
    confidence: 84,
    sector: 'Technology',
    indicators: ['RSI 61', 'Cup & Handle', 'Institutional Buying'],
    aiAnalysis: 'AAPL completing a classic cup-and-handle pattern on the weekly chart. AI segment revenue growing 40% YoY. Strong institutional accumulation detected in options chain. Swing trade targeting $198–$208 over 2–3 weeks.',
    beginnerNote: 'Apple is completing a chart pattern called "Cup and Handle" — imagine a coffee cup shape on the chart. This pattern often leads to a price rally. Apple\'s AI features are driving strong revenue growth, making this a fundamentally sound trade.',
    trend: 'up' as const,
    volume: '+34%',
    lastUpdated: '09:30 AM',
  },
  {
    id: 'trade-006',
    symbol: 'NVDA',
    name: 'NVIDIA Corporation',
    market: 'US',
    exchange: 'NASDAQ',
    cmp: 924.80,
    entry: '$910 – $930',
    stopLoss: 875.0,
    target1: 985.0,
    target2: 1050.0,
    rr: '2.7:1',
    type: 'Swing' as const,
    setup: 'Momentum' as const,
    risk: 'Medium' as const,
    confidence: 91,
    sector: 'Semiconductors',
    indicators: ['RSI 68', 'Trend Continuation', 'AI Demand Catalyst'],
    aiAnalysis: 'NVDA remains in a strong uptrend with AI chip demand far exceeding supply. Pullback to 10 EMA provides a low-risk entry point. Earnings catalyst in 3 weeks adds upside potential. Highest confidence setup today.',
    beginnerNote: 'NVIDIA makes the chips that power AI systems like ChatGPT. Demand for these chips is extremely high. The stock pulled back slightly to a support level, which is a good entry opportunity. This is our highest-confidence trade today at 91%.',
    trend: 'up' as const,
    volume: '+156%',
    lastUpdated: '09:32 AM',
  },
  {
    id: 'trade-007',
    symbol: 'BTC/USD',
    name: 'Bitcoin / US Dollar',
    market: 'Crypto',
    exchange: 'Crypto',
    cmp: 67420.0,
    entry: '$66,500 – $68,000',
    stopLoss: 63500,
    target1: 72000,
    target2: 78500,
    rr: '2.3:1',
    type: 'Swing' as const,
    setup: 'Breakout' as const,
    risk: 'High' as const,
    confidence: 72,
    sector: 'Crypto',
    indicators: ['RSI 58', 'Weekly Resistance Break', 'ETF Inflows'],
    aiAnalysis: 'BTC broke above $67,000 weekly resistance on strong ETF inflow data ($420M in 24hrs). Next resistance at $72,000–$74,000. High volatility asset — use smaller position size (max 2% portfolio). Halving cycle tailwind active.',
    beginnerNote: 'Bitcoin broke above an important price level it had been stuck below for weeks. Large institutions are buying Bitcoin ETFs, which pushes the price up. This is a high-risk trade — crypto prices move fast. Only invest a small amount you can afford to lose.',
    trend: 'up' as const,
    volume: '+203%',
    lastUpdated: '09:15 AM',
  },
  {
    id: 'trade-008',
    symbol: 'EUR/USD',
    name: 'Euro / US Dollar',
    market: 'Forex',
    exchange: 'Forex',
    cmp: 1.0842,
    entry: '1.0820 – 1.0860',
    stopLoss: 1.0760,
    target1: 1.0950,
    target2: 1.1040,
    rr: '2.2:1',
    type: 'Swing' as const,
    setup: 'Reversal' as const,
    risk: 'Medium' as const,
    confidence: 74,
    sector: 'Major Pairs',
    indicators: ['RSI 52', 'Key Support Hold', 'ECB Dovish'],
    aiAnalysis: 'EUR/USD holding above 1.0820 key support after ECB signals slower rate hike pace. US CPI cooling reduces USD strength. Technical setup shows potential reversal from support. Forex trade — use proper lot sizing.',
    beginnerNote: 'This is a Forex (currency) trade. You\'re essentially betting that the Euro will become stronger compared to the US Dollar. The Euro held a key support level and the US Dollar is weakening due to lower inflation data. A good risk/reward setup.',
    trend: 'up' as const,
    volume: '+28%',
    lastUpdated: '09:20 AM',
  },
  {
    id: 'trade-009',
    symbol: 'SUNPHARMA',
    name: 'Sun Pharmaceutical',
    market: 'Indian',
    exchange: 'NSE',
    cmp: 1624.80,
    entry: '1,610 – 1,630',
    stopLoss: 1555,
    target1: 1720,
    target2: 1820,
    rr: '2.9:1',
    type: 'Swing' as const,
    setup: 'Momentum' as const,
    risk: 'Low' as const,
    confidence: 85,
    sector: 'Pharma',
    indicators: ['RSI 64', 'Sector Strength', 'FII Buying'],
    aiAnalysis: 'SUNPHARMA leading pharma sector breakout with strong FII accumulation detected. US FDA approvals pipeline strong. Sector rotation into defensives supports trade. Clean risk/reward with defined levels.',
    beginnerNote: 'Sun Pharma is India\'s largest pharmaceutical company. The pharma sector is performing well today and FII (big foreign investors) are buying this stock. The trade has a great risk/reward ratio of 2.9:1, meaning potential profit is nearly 3 times the risk.',
    trend: 'up' as const,
    volume: '+74%',
    lastUpdated: '09:36 AM',
  },
  {
    id: 'trade-010',
    symbol: 'MARUTI',
    name: 'Maruti Suzuki India',
    market: 'Indian',
    exchange: 'NSE',
    cmp: 12840.50,
    entry: '12,750 – 12,860',
    stopLoss: 12450,
    target1: 13400,
    target2: 14100,
    rr: '2.5:1',
    type: 'Swing' as const,
    setup: 'Breakout' as const,
    risk: 'Medium' as const,
    confidence: 78,
    sector: 'Auto',
    indicators: ['RSI 60', 'Monthly Breakout', 'Strong Demand Data'],
    aiAnalysis: 'MARUTI breaking out of a monthly consolidation range. April auto sales data showed 12% YoY growth. Rural demand recovery and new EV launches are positive catalysts. Monthly breakout targets 13,400–14,100.',
    beginnerNote: 'Maruti Suzuki is India\'s largest car maker. It recently reported strong sales data and the stock is breaking out of a pattern it was stuck in for a month. Strong sales = strong profits = higher stock price. A medium-confidence, medium-risk swing trade.',
    trend: 'up' as const,
    volume: '+51%',
    lastUpdated: '09:39 AM',
  },
  {
    id: 'trade-011',
    symbol: 'WIPRO',
    name: 'Wipro Ltd',
    market: 'Indian',
    exchange: 'NSE',
    cmp: 468.20,
    entry: '462 – 470',
    stopLoss: 445,
    target1: 495,
    target2: 520,
    rr: '2.0:1',
    type: 'Intraday' as const,
    setup: 'Momentum' as const,
    risk: 'Medium' as const,
    confidence: 71,
    sector: 'IT',
    indicators: ['RSI 56', 'VWAP Bounce', 'IT Sector Momentum'],
    aiAnalysis: 'WIPRO bouncing from VWAP with IT sector tailwind from TCS results. Intraday momentum trade. Volume above average. Exit before 2:30 PM to avoid late-session volatility.',
    beginnerNote: 'This is a same-day trade riding the positive wave in the IT sector after TCS\'s strong results. When TCS does well, other IT companies like Wipro also tend to rise. Simple momentum trade — buy, let it run to the target, exit before market close.',
    trend: 'up' as const,
    volume: '+62%',
    lastUpdated: '09:41 AM',
  },
  {
    id: 'trade-012',
    symbol: 'GOLD',
    name: 'Gold (MCX)',
    market: 'Indian',
    exchange: 'MCX',
    cmp: 73450,
    entry: '₹73,200 – ₹73,500',
    stopLoss: 72400,
    target1: 74800,
    target2: 76200,
    rr: '2.4:1',
    type: 'Swing' as const,
    setup: 'Momentum' as const,
    risk: 'Low' as const,
    confidence: 80,
    sector: 'Commodities',
    indicators: ['RSI 57', 'Safe Haven Demand', 'US CPI Tailwind'],
    aiAnalysis: 'Gold benefiting from cooling US inflation expectations and geopolitical uncertainty. Holding above key ₹73,000 support. Global gold ETF inflows rising. Safe-haven asset — suitable for conservative traders.',
    beginnerNote: 'Gold is a "safe haven" asset — people buy it when they\'re uncertain about other investments. With US inflation cooling, the US Dollar may weaken, which makes gold more valuable. This is one of the safer trades in today\'s list.',
    trend: 'up' as const,
    volume: '+38%',
    lastUpdated: '09:28 AM',
  },
];

export default function TradeIdeasGrid() {
  const [beginnerMode, setBeginnerMode] = useState(false);
  const [expandedId, setExpandedId] = useState<string | null>(null);

  return (
    <div>
      {/* Beginner Mode Toggle */}
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>
          Showing <span className="font-semibold text-foreground">{tradeIdeas.length}</span> trade ideas
        </p>
        <label className="flex items-center gap-2 cursor-pointer select-none">
          <span className="text-sm" style={{ color: 'var(--muted-foreground)' }}>
            Beginner Mode
          </span>
          <button
            role="switch"
            aria-checked={beginnerMode}
            onClick={() => setBeginnerMode(!beginnerMode)}
            className="relative w-10 h-5 rounded-full transition-all duration-200 flex-shrink-0"
            style={{ background: beginnerMode ? 'var(--primary)' : 'var(--muted)' }}
          >
            <span
              className="absolute top-0.5 w-4 h-4 rounded-full transition-all duration-200"
              style={{
                background: 'white',
                left: beginnerMode ? '22px' : '2px',
              }}
            />
          </button>
          {beginnerMode && (
            <span className="text-xs text-positive">Plain English explanations ON</span>
          )}
        </label>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-5">
        {tradeIdeas.map((trade) => (
          <TradeCard
            key={trade.id}
            trade={trade}
            beginnerMode={beginnerMode}
            expanded={expandedId === trade.id}
            onToggleExpand={() =>
              setExpandedId(expandedId === trade.id ? null : trade.id)
            }
          />
        ))}
      </div>
    </div>
  );
}